import { render } from "./Nav.vue?vue&type=template&id=65af85a3&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=65af85a3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65af85a3"],['__file',"src/components/Nav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65af85a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65af85a3', __exports__)) {
    api.reload('65af85a3', __exports__)
  }
  
  module.hot.accept("./Nav.vue?vue&type=template&id=65af85a3&scoped=true", () => {
    api.rerender('65af85a3', render)
  })

}


export default __exports__